import { ITravelFlightAirline } from '@shared/shared/interfaces/travel-flight.interfaces';

export const GET_ALL_FLIGHT_AIRLINES = '[Flight Airlines] Get all flight airlines';
export const GET_ALL_FLIGHT_AIRLINES_SUCCESS = '[Flight Airlines] Get all flight classes airlines';

export class GetAllFlightAirlines {
  readonly type = GET_ALL_FLIGHT_AIRLINES;
}

export class GetAllFlightAirlinesSuccess {
  readonly type = GET_ALL_FLIGHT_AIRLINES_SUCCESS;
  constructor(public payload: Array<ITravelFlightAirline>) {}
}

export type FlightAirlinesActions = GetAllFlightAirlines | GetAllFlightAirlinesSuccess;
